import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { forkJoin, Subscription } from 'rxjs';

import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ElementSchemaRegistry } from '@angular/compiler';
import { isPlatformServer, Location } from '@angular/common'
import { platformServer } from '@angular/platform-server';
import { environment } from 'src/environments/environment';
import { Constants } from 'src/app/common/Constants';
import { MessageService } from 'src/app/common/message.service';
import { PreviewGeneratedCardComponent } from 'src/app/features-modules/preview/components/preview-generated-card/preview-generated-card.component';
import { HTTPService } from 'src/app/services/http.service';
import { SharedService } from 'src/app/services/shared.service';
import { ConfirmationBoxComponent } from 'src/app/shared/components/confirmation-box/confirmation-box.component';
import { LoginComponent } from 'src/app/shared/components/Login/Login.component';
import { CardEditorComponent } from 'src/app/shared/components/card-editor/card-editor.component';
import { FooterService } from 'src/app/footer.service';
import { CardEditorService } from 'src/app/shared/components/card-editor/card-editor.service';


@Component({
  selector: 'app-personalize-card',
  templateUrl: './personalize-card.component.html',
  styleUrls: ['./personalize-card.component.css']
})
export class PersonalizeCardComponent implements OnInit {
  subscription = new Subscription();
  cardId = 0;
  public messageType: any;
  public constants: Constants;
  public VideoFilterModel = { cardId: 0, categoryId: 0, SubcategoryId: 0, StartRow: 0, PageSize: 1200, ScreenType: 1, IsMainHomePageRequest: false };
  isDataLoaded: boolean = false;
  generatedPlaceholderImagePath: string = '';
  generatedOriginalImagePath: string = '';
  originalImagePath: string = '';
  singleFileList: any = [];
  userDetails: any = {};
  cardTemplateId: number = 0;
  categoryId: number = 0;
  subCategoryId: number = 0;
  finalImageState: any = '';
  @ViewChild('fileInput') el: ElementRef;
  @ViewChild('buttoninput') btn: ElementRef;
  @ViewChild('editor') editor: any;
  shapeData: any;
  showCardNote: boolean = true;
  rootClass = "personalize-card personalize-card-editor";
  assetURL = environment.assetURL;
  cardDescription = "";
  @ViewChild('cardEditor') cardEditorComponent!: CardEditorComponent;
  projectConfig: any;
  constructor(private renderer: Renderer2, private ngbModel: NgbModal, private _route: ActivatedRoute,
    private _httpService: HTTPService,
    private messageService: MessageService, public sharedService: SharedService,
    public toastr: ToastrService, private dialog: MatDialog, private _router: Router,
    private modalService: NgbModal, private elem: ElementRef,
    private location: Location, @Inject(PLATFORM_ID) private platformId,
    private footerService: FooterService) {
    this.constants = new Constants();
    this.messageType = this.constants.messageType;
  }
  currentCard: any;
  userCardId: number = 0;
  options: any;
  isDownloadFromWaterMark: boolean = false;
  promises = [];
  isFromSaveEvent: boolean = false;
  myLocale;
  fontFamilyOptions = [];
  imageDownloadLink: any;
  isImageStateChanged = false;
  ngOnInit() {
    this.renderer.addClass(document.body, 'remove-body-padding');
    this.footerService.toggleFooterVisibility(false);
    this.footerService.toggleHeaderVisibility(false);
    this._router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      if (!isPlatformServer(this.platformId)) {
        window.scrollTo(0, 0);
      }
    });

    // this.fontFamilyOptions = [
    //   ['Alisandra Demo', 'Alisandra Demo'],
    //   ['Atiba Regular', 'Atiba Regular'],
    //   ['Unicorn Pop', 'Unicorn Pop'],
    //   ['Libre Baskerville', 'Libre Baskerville'],
    //   ['TeX Gyre Termes', 'TeXGyreTermes'],
    //   ['Learning Curve Pro', 'LearningCurvePro'],
    //   ['"Viaoda Libre"', 'Viaoda Libre'],
    //   ['NotoSansRegular', 'NotoSansRegular'],
    //   ['NotoSansBold', 'NotoSansBold'],
    //   ['Corinthia Regular', 'Corinthia Regular'],
    //   ['Corinthia Bold', 'Corinthia Bold'],

    //   ['Oswald-Bold', 'Oswald-Bold'],
    //   ['Pushster-Regular', 'Pushster-Regular'],
    //   ['Titillium-Web', 'Titillium-Web'],
    //   ['Viaoda-Libre', 'Viaoda-Libre'],

    // ];
    this.subscription.add(
      this._route.paramMap.subscribe((params: any) => {
        const queryData = this.sharedService.decryptAndParseQueryString(params.get("data"));
        if (queryData != undefined) {
          this.cardId = queryData.cardId;
          this.userCardId = queryData.userCardId;
        }
        this.cardDescription = params?.params?.cardDesc;
      })
    );
    this.messageType = this.constants.messageType;
    if (!isNaN(this.cardId) && this.cardId > 0) {
      this.loadCardData();
    }
    else {
      this.loadUserCardData();
    }

  }
  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'remove-body-padding');
    this.footerService.toggleFooterVisibility(true);
    this.footerService.toggleHeaderVisibility(true);
  }
  ngAfterViewInit() {
    this.sharedService.isShowLoader.next(true);
  }
  loadCardData() {
    this.VideoFilterModel.cardId = this.cardId;
    this.subscription.add(
      this._httpService.ajaxPost('homepage/GetHomepageData', this.VideoFilterModel).subscribe(
        data => {
          if (data["Message"].MessageTypeValue == this.messageType.Success || data["Message"].MessageTypeValue == 6) {
            var allCardData = data["AllCardData"];
            this.currentCard = allCardData[0];
            this.projectConfig = JSON.parse(this.currentCard.ImageState);
            this.originalImagePath = environment.baseURL + this.currentCard.OriginalImage;
            const imageElements = this.projectConfig.CardMain.Elements.filter(x => x.type == "image");
            Promise.all(
              imageElements.map(element =>
                this.sharedService.imageToBase64(element.properties.src).then((data: any) => {
                  element.properties.base64 = data;
                })
              )
            ).then(() => {
              this.isDataLoaded = true;
            });
          }
          else {
            this.messageService.showMessage(data["Message"].Text, data["Message"].MessageTypeValue);
          }

          this.cardTemplateId = this.currentCard.CardTemplateId;
          this.categoryId = this.currentCard.CategoryId;
          this.subCategoryId = this.currentCard.SubCategoryId;
          this.sharedService.isShowLoader.next(false);
        },
        (error: any) => {
          this.sharedService.isShowLoader.next(false);
          this.isDataLoaded = true;
          // this.hideSpinner();
          // this.messageService.showMessage(this.constErrors.CommonError, this.messageType.Error);
        }));
  }

  loadUserCardData() {

    this.sharedService.isShowLoader.next(true)
    this.subscription.add(
      this._httpService.ajaxPost(`Personalize/GetCardDetailsFromUserCardId/${this.userCardId}`).subscribe((response: any) => {
        this.currentCard = response;
        this.originalImagePath = environment.baseURL + this.currentCard.OriginalImage;
        this.cardId = this.currentCard.CardId;
        this.projectConfig = JSON.parse(this.currentCard.ImageState);
        const imageElements = this.projectConfig.CardMain.Elements.filter(x => x.type == "image");

        Promise.all(
          imageElements.map(element =>
            this.sharedService.imageToBase64(element.properties.src).then((data: any) => {
              element.properties.base64 = data;
            })
          )
        ).then(() => {
          this.isDataLoaded = true;
          this.sharedService.isShowLoader.next(false);
        });

      }, (error) => {
        this.sharedService.isShowLoader.next(false);
        this.isDataLoaded = true;
      }));

  }
  saveCard() {

  }


  back() {
    this.location.back();
  }
  hideCardNote() {
    this.showCardNote = false;
  }
}
